import React from "react";
import { useNavigate } from "react-router-dom";
import ThemeToggle from "./ThemeToggle";

const ITEMS = [
  { key: "inicio",    label: "Início",    route: "/passenger-home" },
  { key: "atividade", label: "Atividade", route: "/atividade" },
  { key: "conta",     label: "Conta",     route: "/conta" },
];

const ICONS = {
  inicio: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
      stroke={active ? "#18d7e5" : "#9aa4b8"}
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      style={{ transition: "stroke 0.2s" }}>
      <path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H5a1 1 0 01-1-1V9.5z"/>
      <path d="M9 21V12h6v9"/>
    </svg>
  ),
  atividade: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
      stroke={active ? "#18d7e5" : "#9aa4b8"}
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      style={{ transition: "stroke 0.2s" }}>
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
    </svg>
  ),
  conta: (active) => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
      stroke={active ? "#18d7e5" : "#9aa4b8"}
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      style={{ transition: "stroke 0.2s" }}>
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>
  ),
};

export default function BottomNav({ active = "inicio" }) {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .zuno-nav-item { -webkit-tap-highlight-color: transparent; }
        .zuno-nav-item:active { transform: scale(0.96); }
      `}</style>

      <div className="zuno-bottom-nav" data-reference-ui="true" style={{
        position: "fixed", bottom: 12, left: "50%", transform: "translateX(-50%)",
        width: "min(540px, calc(100% - 32px))",
        height: "70px",
        background: "rgba(7, 9, 13, 0.86)",
        backdropFilter: "blur(24px)",
        WebkitBackdropFilter: "blur(24px)",
        border: "1px solid rgba(255,255,255,0.11)",
        borderRadius: 22,
        display: "flex", justifyContent: "space-around", alignItems: "center",
        zIndex: 500,
        boxShadow: "0 24px 70px rgba(0,0,0,0.34)",
      }}>
        {ITEMS.map(({ key, label, route }) => {
          const isActive = active === key;
          return (
            <button
              key={key}
              className="zuno-nav-item"
              onClick={() => navigate(route)}
              aria-current={isActive ? "page" : undefined}
              style={{
                display: "flex", flexDirection: "column", alignItems: "center",
                gap: "5px", cursor: "pointer",
                padding: "8px 24px",
                borderRadius: "16px",
                position: "relative",
                transition: "transform 0.15s ease", border:0, background:"transparent", color:"inherit",
              }}
            >
              {/* Ponto indicador no topo */}
              {isActive && (
                <div className="zuno-nav-indicator" aria-hidden="true" />
              )}

              <div style={{ position: "relative", zIndex: 1 }}>
                {ICONS[key](isActive)}
              </div>

              <span style={{
                fontSize: "11px",
                fontWeight: isActive ? "700" : "500",
                color: isActive ? "#18d7e5" : "#9aa4b8",
                letterSpacing: "0.2px",
                transition: "all 0.2s",
                position: "relative", zIndex: 1,
              }}>
                {label}
              </span>
            </button>
          );
        })}
        <div className="zuno-nav-theme"><ThemeToggle /></div>
      </div>
    </>
  );
}
